var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41423",
    "data-name": "Group 41423",
    transform: "translate(11886 4011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15701",
    "data-name": "Rectangle 15701",
    width: 16,
    height: 16,
    transform: "translate(-11886 -4011)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g999",
    transform: "translate(-11885 -3327.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1001",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1003",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1009",
    transform: "translate(2.898 0.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    d: "M-195.9,0l4.1,4h-1.846V9.734h-4.512V4H-200Z",
    transform: "translate(200)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1013",
    transform: "translate(4.334 -670.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    d: "M-254.667,0H-260",
    transform: "translate(259.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1017",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1019",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1025",
    transform: "translate(4.334 13.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    d: "M-254.667,0H-260",
    transform: "translate(259.999 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpOutlined);
export default __webpack_public_path__ + "static/media/arrow-up-outlined.400d23dd8008d56a8c9215e9f3421cdd.svg";
export { ForwardRef as ReactComponent };